<template>
  <div>
    <h3 class="mt-5">
      <span class="mr-3 fa-square-primary">
        <font-awesome :icon="['far', group.icon]"/>
      </span>

      {{ group.name }}
    </h3>

    <div class="card">
      <ul class="list-data no-links">
        <li class="data-heading d-none d-xl-block">
          <div class="row">
            <div class="col-12 col-sm-12 col-lg-12 col-xl-4">Capability Name</div>
            <div class="col-12 col-sm-6 col-lg-3 col-xl-2">Level</div>
            <div class="col-12 col-sm-6 col-lg-4 col-xl-3">Start of Placement</div>
            <div class="col-12 col-sm-12 col-lg-5 col-xl-3">End of Placement</div>
          </div><!-- /.row -->
        </li>
        <capability-item v-for="capability in group.capabilities" :capability="capability" :key="capability.id"/>
      </ul><!-- /.list-data -->
    </div><!-- /.card -->
  </div>
</template>

<script>
import { placementCapabilitiesComputed } from 'vx/helpers'
import CapabilityItem from './PlacementsEndComponentCapabilitiesItem'
export default {
  inject: ['$validator'],

  props: {
    group: {
      required: true,
      type: Object
    }
  },

  components: {
    CapabilityItem
  },

  computed: {
    ...placementCapabilitiesComputed
  }
}
</script>
